import { MarketRow } from "./market-row";
import { MarketCardBorrow, MarketCardDeposit } from "./market-card";
import { AssetCardBorrow, AssetCardDeposit } from "./asset-card";
import { PositionBorrow, PositionDeposit } from "./position";
import { getBorrowAprMetrics, getDepositAprMetrics } from "./utils";

export const AprDisplay = {
  MarketRow,
  MarketCardDeposit,
  MarketCardBorrow,
  AssetCardDeposit,
  AssetCardBorrow,
  PositionDeposit,
  PositionBorrow,
  getDepositAprMetrics,
  getBorrowAprMetrics,
};
